import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalHands = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.625 7C17.625 6.83424 17.5592 6.67527 17.4419 6.55806C17.3247 6.44085 17.1658 6.375 17 6.375H13.875V3.25C13.875 3.08424 13.8092 2.92527 13.6919 2.80806C13.5747 2.69085 13.4158 2.625 13.25 2.625H10.75C10.5842 2.625 10.4253 2.69085 10.3081 2.80806C10.1908 2.92527 10.125 3.08424 10.125 3.25V6.375H7C6.83424 6.375 6.67527 6.44085 6.55806 6.55806C6.44085 6.67527 6.375 6.83424 6.375 7V9.5C6.375 9.66576 6.44085 9.82473 6.55806 9.94194C6.67527 10.0592 6.83424 10.125 7 10.125H10.125V13.25C10.125 13.4158 10.1908 13.5747 10.3081 13.6919C10.4253 13.8092 10.5842 13.875 10.75 13.875H13.25C13.4158 13.875 13.5747 13.8092 13.6919 13.6919C13.8092 13.5747 13.875 13.4158 13.875 13.25V10.125H17C17.1658 10.125 17.3247 10.0592 17.4419 9.94194C17.5592 9.82473 17.625 9.66576 17.625 9.5V7Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.125 21.375L3.44667 19.3908C2.91478 18.7259 2.625 17.8998 2.625 17.0483V12.7392C2.625 12.4076 2.7567 12.0897 2.99112 11.8553C3.22554 11.6209 3.54348 11.4892 3.875 11.4892V11.4892C4.20652 11.4892 4.52446 11.6209 4.75888 11.8553C4.9933 12.0897 5.125 12.4076 5.125 12.7392V15.8642"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.87495 21.375V18.875C8.87529 18.1334 8.65576 17.4085 8.24412 16.7917L7.29245 15.3667C7.21091 15.2316 7.10282 15.1145 6.97471 15.0224C6.84661 14.9303 6.70116 14.8651 6.54715 14.8308C6.39315 14.7966 6.23379 14.7939 6.07872 14.823C5.92365 14.852 5.77609 14.9123 5.64495 15V15C5.4094 15.1578 5.23938 15.396 5.16668 15.6701C5.09399 15.9442 5.12359 16.2353 5.24995 16.4892L6.37662 18.3642"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.875 21.375L20.5533 19.3908C21.0852 18.7259 21.375 17.8998 21.375 17.0483V12.7392C21.375 12.4076 21.2433 12.0897 21.0089 11.8553C20.7745 11.6209 20.4565 11.4892 20.125 11.4892C19.7935 11.4892 19.4755 11.6209 19.2411 11.8553C19.0067 12.0897 18.875 12.4076 18.875 12.7392V15.8642"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.125 21.375V18.875C15.1247 18.1335 15.3442 17.4085 15.7558 16.7917L16.7075 15.365C16.7888 15.2297 16.8967 15.1122 17.0246 15.0198C17.1526 14.9274 17.298 14.8619 17.452 14.8273C17.6061 14.7927 17.7655 14.7897 17.9207 14.8186C18.0759 14.8474 18.2237 14.9074 18.355 14.995V14.995C18.5917 15.1527 18.7626 15.3914 18.8356 15.6662C18.9087 15.9411 18.8788 16.2331 18.7517 16.4875L17.625 18.3625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalHands.displayName = 'SvgMedicalHands';
export default SvgMedicalHands;
